import DefaultButton from '@pc/components/Works/Panel/shared/Button/DefaultButton'
import type { ComponentPropsWithoutRef } from 'react'

const AreaPanelButton = ({ className = '', ...props }: ComponentPropsWithoutRef<'button'>) => (
  <DefaultButton className={`h-10 min-w-30 grow ${className}`} {...props} />
)

export default AreaPanelButton
